import {showConverterUIPopup} from './showConverterUIPopup';

// Клик по ссылке формата — общий для одиночного видео (ItemResultDefault.vue)
// и карточки плейлиста (PlaylistCard.vue). Формат конвертера открывает попап
// вместо перехода; остальные идут по ссылке и шлют download-click в корень
// (GA, clickAds, tzLandingFree). eventLabel — event_label события download_click
// ('playlist' у карточки плейлиста, у одиночного видео не задаётся).
export function handleFormatDownload(vm, format, e, eventLabel) {
  if (format?.isConverterUI) {
    e.preventDefault()
    const gaResource = 'G-PLS2TZW26G'
    const clickAdsExperiment = window['clickAds']

    showConverterUIPopup(
      format.url,
      '#7ed338',
      clickAdsExperiment?.url || '',
      {
        gaResource,
        adsGaResource: gaResource,
      }
    )
  } else {
    vm.$root.$emit('download-click', format.ext ?? format.type ?? format.name, eventLabel)
  }
}
